import { CssBaseline } from "@material-ui/core";
import { ThemeProvider } from "@material-ui/styles";
import * as React from "react";
import getThemeById from "./themes/themeMapper";

let loadedThemeIdentifier = null;
export function withRoot(Component: any) {
  function WithRoot(props: any) {
    const query = new URLSearchParams(window.location.search);
    const opcoIdFromUrl = query.get("theme") ?? "";
    loadedThemeIdentifier = opcoIdFromUrl;
    const theme = getThemeById(opcoIdFromUrl);

    console.log(theme);

    // MuiThemeProvider makes the theme available down the React tree
    // thanks to React context.
    return (
      <ThemeProvider theme={theme}>
        {/* Reboot kickstart an elegant, consistent, and simple baseline to build upon. */}
        <CssBaseline />
        <Component {...props} />
      </ThemeProvider>
    );
  }

  return WithRoot;
}

export { loadedThemeIdentifier };
